import React from "react";
import { ShieldCheck, ShieldAlert, ShieldX, HelpCircle, Ban, FileWarning, FileClock } from "lucide-react";

const MAP = {
    "PEC verificata": { cls: "bg-[#16A34A]/10 text-[#16A34A] border-[#16A34A]/30", Icon: ShieldCheck },
    "PEC con avvertenze": { cls: "bg-[#F59E0B]/10 text-[#B45309] border-[#F59E0B]/30", Icon: ShieldAlert },
    "PEC anomala": { cls: "bg-[#DC2626]/10 text-[#DC2626] border-[#DC2626]/30", Icon: ShieldX },
    "Non verificabile": { cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: HelpCircle },
    "Non PEC": { cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: Ban },
    "Firma non valida": { cls: "bg-[#DC2626]/10 text-[#DC2626] border-[#DC2626]/30", Icon: FileWarning },
    "Certificato scaduto": { cls: "bg-[#F59E0B]/10 text-[#B45309] border-[#F59E0B]/30", Icon: FileClock },
};

export function TechnicalStatusBadge({ status = "Non verificabile", className = "" }) {
    const v = MAP[status] || MAP["Non verificabile"];
    const { Icon } = v;
    return (
        <span
            data-testid="technical-status-badge"
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium border ${v.cls} ${className}`}
        >
            <Icon className="w-3.5 h-3.5" strokeWidth={2} />
            {status}
        </span>
    );
}

export default TechnicalStatusBadge;
